import { Injectable } from '@angular/core';
import { UtilService } from '../util/util.service';
import { AccessToken } from './model/access-token';

@Injectable({ providedIn: 'root' })
export class TokenService {
  private _utilService: UtilService;

  public constructor(utilService: UtilService) {
    this._utilService = utilService;
  }

  public isBackOfficeToken(tokenString: string): boolean {
    const token = this.decodeJwt(tokenString);
    const subject = this.getTokenSubjectClaim(token);
    const subjectParts = subject.split('_');
    return subjectParts.length > 2 && subjectParts[1].toLowerCase() === 'u';
  }

  public decodeJwt = (jwt: string): AccessToken => {
    let token = new AccessToken();

    let jwtArray = jwt.split('.');

    token.Header = this.decode(jwtArray[0]);
    token.Payload = this.decode(jwtArray[1]);
    token.Signature = this.decode(jwtArray[2]);

    //json parse this so it becomes an object and not a raw string
    if (token.Payload) {
      token.Payload = JSON.parse(token.Payload);
    }
    return token;
  };

  public tokenHasSubjectClaim = (token: AccessToken): boolean => {
    let bol = false;
    let tokenPayload = token.Payload;
    //if it has a sub (subject) in the payload
    if (tokenPayload['sub']) {
      let tokenSubject: string = tokenPayload['sub'].toString();
      if (this._utilService.isNotNullEmptyOrWhitespace(tokenSubject)) {
        bol = true;
      }
    }

    return bol;
  };

  public getTokenSubjectClaim = (token: AccessToken): string => {
    let subject = '';

    if (this.tokenHasSubjectClaim(token)) {
      let tokenPayload = token.Payload;
      //if it has a sub (subject) in the payload
      let tokenSubject = tokenPayload['sub'];
      subject = tokenSubject.toString();
    }

    return subject;
  };

  private b64DecodeUnicode = (str) => {
    return decodeURIComponent(
      atob(str).replace(/(.)/g, function (m, p) {
        var code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) {
          code = '0' + code;
        }
        return '%' + code;
      })
    );
  };

  private decode = (str) => {
    var output = str.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
      case 0:
        break;
      case 2:
        output += '==';
        break;
      case 3:
        output += '=';
        break;
      default:
        throw 'Illegal base64url string!';
    }

    try {
      return this.b64DecodeUnicode(output);
    } catch (err) {
      return atob(output);
    }
  };
}
